"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fns = require("@react-pdf/fns");

var getTop = function getTop(node) {
  var _node$box;

  return ((_node$box = node.box) === null || _node$box === void 0 ? void 0 : _node$box.top) || 0;
};

var hasFixedHeight = function hasFixedHeight(node) {
  var _node$style;

  return !(0, _fns.isNil)((_node$style = node.style) === null || _node$style === void 0 ? void 0 : _node$style.height);
};

var splitNode = function splitNode(node, height) {
  if (!node) return [null, null];
  var nodeTop = getTop(node);
  var current = Object.assign({}, node, {
    box: (0, _extends2.default)({}, node.box, {
      borderBottomWidth: 0
    }),
    style: (0, _extends2.default)({}, node.style, {
      marginBottom: 0,
      paddingBottom: 0,
      borderBottomWidth: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    })
  });
  current.style.height = height - nodeTop;
  var nextHeight = hasFixedHeight(node) ? node.box.height - (height - nodeTop) : null;
  var next = Object.assign({}, node, {
    box: (0, _extends2.default)({}, node.box, {
      top: 0,
      borderTopWidth: 0
    }),
    style: (0, _extends2.default)({}, node.style, {
      marginTop: 0,
      paddingTop: 0,
      borderTopWidth: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    })
  });

  if (nextHeight) {
    next.style.height = nextHeight;
  }

  return [current, next];
};

var _default = splitNode;
exports.default = _default;